import axios from 'axios'
import Vue from 'vue'
import { store } from '@/store'

const $axios = axios.create()

$axios.CancelToken = axios.CancelToken
$axios.isCancel = axios.isCancel

// We need to intercept the requests and add header (if logged in)
$axios.interceptors.request.use((config) => {

  // Add token if it exists
  if (store && store.state && store.state.auth && store.state.auth.user) {
    const token = store.state.auth.user.token

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  return config
})

// We also need to intercept the responses to see if we are authorized
$axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response) {

    // Check if 401/403
    // const loginPages = [ '/', '/onboarding' ]

    // console.log(window.location.pathname)
    // console.log(typeof window.location.pathname)
    // console.log(error.response.status)
    // console.log(window.location.search)
    // console.log(loginPages.some(x => window.location.pathname.includes(x)))

    if (window.location.pathname !== '/' && (error.response.status === 401 || error.response.status === 403)) {
      Vue.prototype.$alertOptions({
        title: 'Sessionen slut',
        text: 'Du måste logga in igen',
        type: 'warning',
        confirmButtonText: 'Ok',
        allowOutsideClick: false
      }).then(() => {
        window.location = '/'
      })
    }

    // Display response data if existing
    if (error.response.data) {
      if (error.response.data.message !== undefined) {
        // Vue.prototype.$toast(error.response.data.message, 'error', 'exclamation-triangle', true, 5000)
        console.error(error.response.data.message)
      } else {
        let allErrors = error.response.data.errors
        for (var i in allErrors) {
          // Vue.prototype.$toast(allErrors[i].message, 'error', 'exclamation-triangle', true, 5000)
          console.error(allErrors[i].message)
        }
      }
    }
  }

  return Promise.reject(error.response)
})

export default $axios



// WEBPACK FOOTER //
// ./src/axios-instance.js